import React from "react"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

const ContentsLink = styled(Typography)(({ theme }) => ({
  display: "inline",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "18px",
  lineHeight: "1.45",
  color: "#3374da",
  marginRight: "5px",
  verticalAlign: "middle",
  "&:hover": {
    textDecoration: "underline",
  },
}))

const TopLinkCardLink = (props) => {
  return <ContentsLink>{props.children}</ContentsLink>
}

export default TopLinkCardLink
